<template>
  <renraku-search-form />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import RenrakuSearchForm from '@/components/renraku/search/Form.vue'
import { useRenrakuStore } from '@/store/renraku';
import { RouterConst } from '@/const/Router';
import { onBeforeRouteLeave } from 'vue-router';

export default defineComponent({
  beforeRouteEnter(to, from, next) {
    const store = useRenrakuStore();
    if (from.name != RouterConst.RENRAKU_DETAIL) {
      // 検索情報の削除
      store.removePage();
    }
    next()
  },
  setup() {
    const store = useRenrakuStore();
    onBeforeRouteLeave((to, from, next) => {
      if (to.name != RouterConst.RENRAKU_DETAIL) {
        // 検索情報の削除
        store.removePage();
      }
      next()
    })
    return {}
  },
  components: {
    'renraku-search-form': RenrakuSearchForm
  }
})
</script>
